import styled from "styled-components";

export const Form = styled.section`
  ${({ theme, gridTemplate }) => gridTemplate && gridTemplate(theme)};
  display: grid;
  /* grid-gap: ${({ theme: { spacings: { xxsmall }}}) =>  xxsmall }; */
`;
